import React from 'react';
import ButtonComponent from '../../../../../components/Buttons/ButtonComponent';
import { Grid } from '@mui/material';

const ButtonCreateEditTemporaryReceipt = ({
    isApprovedAcc,
    check,
    Save,
    DataRegUserAccess,
    isEdit,
    Print,
    AddNew,
    isUnapproved,
    Approve,
    UnApprove,
    Printing
}) => {

    const renderButton = (data) => {
        switch (data.accessCode) {
            case 'PRI':
                return isEdit ? ButtonComponent.PrintButton(Print, '', true) : null;
            case 'CRE':
                return isEdit ? ButtonComponent.AddButton(AddNew, 'New', false, isUnapproved, true) : null;
            case 'APP':
                return !isApprovedAcc && isEdit ? ButtonComponent.ApproveButton(Approve, 'Approve', true) : null;
            case 'UPP':
                return isEdit && isApprovedAcc ? ButtonComponent.UnApproveButton(UnApprove, 'Un Approve', true) : null;
            default:
                return null;
        }
    };

    return (
        <div className="row" style={{ marginTop: '16px' }}>
            <div className="col-12">
                <Grid
                    container
                    item
                    justifyContent="right"
                    direction="row"
                    style={{ maxWidth: "100vw", gap: "12px" }}
                >
                    {!isApprovedAcc && check !== 0 && Printing === 0 && (
                        ButtonComponent.SaveButton(() => Save(false), false, false, true)
                    )}

                    {DataRegUserAccess.map((data) => (
                        <React.Fragment key={data.accessId}>
                            {renderButton(data)}
                        </React.Fragment>
                    ))}
                </Grid>
            </div>
        </div>
    );
}

export default ButtonCreateEditTemporaryReceipt;